export default "__VITE_ASSET__8c48b521__"